import React, { Component } from "react";
import { ControlLabel, Col, FormGroup } from "react-bootstrap";
import { observer } from "mobx-react";
import "./LabelValuePair.css";

export default observer(
  class LabelValuePair extends Component {
    render() {
      const { label, className, validationState } = this.props;

      return (
        <FormGroup
          className={`label-value-pair ${className || ""}`}
          validationState={validationState}
        >
          <Col componentClass={ControlLabel} sm={3}>
            {label}
          </Col>
          <Col sm={9} className="value">
            {this.props.children}
          </Col>
        </FormGroup>
      );
    }
  }
);



// WEBPACK FOOTER //
// ./src/Core/Components/FormGroups/LabelValuePair/index.js